const FEATURE_HELP_URLS = {
  agent_bots: 'https://aidexa.ai/guide/hc/agent-bots',
  agents: 'https://aidexa.ai/guide/hc/agents',
  audit_logs: 'https://aidexa.ai/guide/hc/audit-logs',
  campaigns: 'https://aidexa.ai/guide/hc/campaigns',
  canned_responses: 'https://aidexa.ai/guide/hc/canned',
  channel_email: 'https://aidexa.ai/guide/hc/email',
  channel_facebook: 'https://aidexa.ai/guide/hc/fb',
  custom_attributes: 'https://aidexa.ai/guide/hc/custom-attributes',
  dashboard_apps: 'https://aidexa.ai/guide/hc/dashboard-apps',
  help_center: 'https://aidexa.ai/guide/hc/help-center',
  inboxes: 'https://aidexa.ai/guide/hc/inboxes',
  integrations: 'https://aidexa.ai/guide/hc/integrations',
  labels: 'https://aidexa.ai/guide/hc/labels',
  macros: 'https://aidexa.ai/guide/hc/macros',
  message_reply_to: 'https://aidexa.ai/guide/hc/reply-to',
  reports: 'https://aidexa.ai/guide/hc/reports',
  sla: 'https://aidexa.ai/guide/hc/sla',
  team_management: 'https://aidexa.ai/guide/hc/teams',
  webhook: 'https://aidexa.ai/guide/hc/webhooks',
  billing: 'https://aidexa.ai/guide/pricing',
  saml: 'https://aidexa.ai/guide/hc/saml',
};

export function getHelpUrlForFeature(featureName) {
  return FEATURE_HELP_URLS[featureName];
}
